import { useEffect } from "react";

let bodyScrollLockCount = 0;
let originalBodyOverflow = "";
let originalHtmlOverflow = "";

export function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active || typeof document === "undefined") return;

    if (bodyScrollLockCount === 0) {
      originalBodyOverflow = document.body.style.overflow || "";
      originalHtmlOverflow = document.documentElement.style.overflow || "";
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }

    bodyScrollLockCount += 1;

    return () => {
      bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1);
      if (bodyScrollLockCount === 0) {
        document.body.style.overflow = originalBodyOverflow;
        document.documentElement.style.overflow = originalHtmlOverflow;
      }
    };
  }, [active]);
}
